import { css } from '@emotion/core'
import styled from '@emotion/styled-base'
import * as React from 'react'

import { Button, spacing, Text, typography } from 'main/ui'

const buttonStyles = css`
  align-items: center;
  display: flex;
`

const StyledText = styled(Text)`
  color: inherit;
  font-weight: ${typography.fontWeight.bold};
  margin: 0 auto;
`

interface IProps {
  full: boolean
  icon: React.ReactNode
  kind: 'regular' | 'outline' | 'soft_disabled'
  label: string
  pendo?: string
  onClick: () => void
}

export default function CTAButton(props: IProps) {
  const { full, icon, kind, label, pendo, onClick } = props

  return (
    <Button kind={kind} onClick={onClick} full={full} css={buttonStyles} data-pendo={pendo}>
      {icon}
      {!!label.length && (
        <StyledText style={{ marginLeft: `${full ? null : `${spacing.majorScale(3)}px`}` }}>
          {label}
        </StyledText>
      )}
    </Button>
  )
}
